import { Tutorial } from '../tutorial.model';

/**
 * O tour da FICHA do cliente (`/painel/listagem/clientes/<id>`).
 *
 * Roteiro do dono (06/09/2026). A ficha tem três zonas que fazem coisas
 * diferentes, e a confusão que o tour existe para desfazer é uma só: os dois
 * tipos de documento têm nomes parecidos e naturezas opostas — um é a lista que
 * ESTE cadastro precisa entregar, o outro é o arquivo do menu Administrativo
 * que aponta para este cliente.
 *
 * A rota tem parâmetro; ver `casaComParametro` em `tours/index.ts`, e a ordem
 * que faz `/clientes/criar` não cair aqui.
 */
export const CLIENTE_FICHA_TOUR: Tutorial = {
  id: 'cliente-ficha',
  rota: '/painel/listagem/clientes/:id',
  passos: [
    {
      alvo: 'cliente-ficha.acoes',
      titulo: 'Editar e inativar ficam aqui em cima',
      corpo:
        'Editar abre o cadastro completo e volta para esta ficha ao terminar. Inativar não apaga ' +
        'nada: o cliente some das escolhas de conta a receber e continua com todo o histórico, ' +
        'pronto para ser reativado.',
      posicao: 'abaixo',
    },
    {
      alvo: 'cliente-ficha.indicadores',
      titulo: 'Indicadores: a saúde do cliente em números',
      corpo:
        'A coluna da direita resume a relação financeira: o que está em aberto, o que já venceu e ' +
        'desde quando ele é cliente. É para bater o olho antes de negociar ou de liberar um novo ' +
        'pedido, sem precisar abrir as contas uma a uma.',
      posicao: 'esquerda',
    },
    {
      alvo: 'cliente-ficha.abas',
      titulo: 'Os dados ficam nas abas, e dá para copiar',
      corpo:
        'Dados básicos, Contato e Endereços mostram tudo que está cadastrado; campo vazio aparece ' +
        'com um traço, para você ver o que falta. Nos telefones e e-mails há o botão de copiar, ' +
        'e o telefone com WhatsApp abre a conversa direto no clique.',
      posicao: 'acima',
    },
    {
      alvo: 'cliente-ficha.contas',
      titulo: 'Contas a receber deste cliente',
      corpo:
        'Todas as cobranças ligadas a ele, sem passar pela listagem geral e filtrar. Clicando em ' +
        'uma conta você abre a mesma tela de sempre, com boleto, nota fiscal e documentos ' +
        'auxiliares.',
      posicao: 'acima',
    },
    {
      alvo: 'cliente-ficha.documentos-administrativos',
      titulo: 'Documentos administrativos: o arquivo que aponta para ele',
      corpo:
        'São os documentos do menu Administrativo que foram vinculados a este cliente (contrato ' +
        'assinado, aditivo, procuração), cada um com sua validade. Eles nascem lá e aparecem ' +
        'aqui.',
      posicao: 'acima',
    },
    {
      alvo: 'cliente-ficha.documentos-cadastrais',
      alvoAlternativo: 'cliente-ficha.abas',
      titulo: 'Documentos cadastrais: o que o cadastro exige',
      corpo:
        'Outra coisa: é a lista que você definiu em Perfis de documento para este tipo de ' +
        'cadastro, e o que já foi enviado dela. Serve para saber se a ficha está completa, não ' +
        'para arquivar contrato.',
      posicao: 'acima',
    },
  ],
};
